/* tslint:disable */
/* eslint-disable */
/**
 * Supply API Gateway
 * A REST API responsible to serve and compose all supply-related data available at Taster
 *
 * The version of the OpenAPI document: 1.63
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * An enumeration.
 * @export
 */
export const ProviderInvoicing = {
    Taster: 'TASTER',
    ThirdParty: 'THIRD_PARTY',
    UnknownDefaultOpenApi: '11184809'
};
export function ProviderInvoicingFromJSON(json) {
    return ProviderInvoicingFromJSONTyped(json, false);
}
export function ProviderInvoicingFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ProviderInvoicingToJSON(value) {
    return value;
}
